export const TYPES = {
  ACTIVATED: 'activated',
  AVAILABLE: 'available',
  ALL: 'all',
}
export const EVENTS = {
  FS_BONUS_ACTIVATED: 'fs_bonus_activated',
}
